import React, { useState } from "react";

const S = {
  card:{background:"#fff",border:"0.5px solid #e0dfd8",borderRadius:12,padding:"16px 20px",marginBottom:16},
  btn:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnPrimary:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"none",background:"#2CA01C",color:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
};

export default function QBO() {
  const [connected, setConnected] = useState(false);
  return (
    <div>
      <div style={{fontSize:14,fontWeight:500,marginBottom:14}}>QuickBooks Online Integration</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        <div style={S.card}>
          <div style={{fontSize:13,fontWeight:500,color:"#2CA01C",marginBottom:4}}>QuickBooks Online</div>
          <div style={{fontSize:12,color:"#888",marginBottom:12}}>Connect your QBO account to sync clients, invoices, and financial data.</div>
          {connected
            ? <>
                <div style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:11,color:"#3B6D11",background:"#EAF3DE",padding:"3px 10px",borderRadius:20,marginBottom:12}}>
                  <div style={{width:6,height:6,borderRadius:"50%",background:"#3B6D11"}}></div> Connected
                </div>
                <div style={{fontSize:12,color:"#888",marginBottom:12}}>Ficsori Accounting<br/><span style={{fontSize:11,color:"#aaa"}}>Last synced: just now</span></div>
                <div style={{display:"flex",gap:8}}>
                  <button style={{...S.btn,fontSize:12}}>↺ Sync Now</button>
                  <button style={{...S.btn,fontSize:12,color:"#A32D2D"}} onClick={()=>setConnected(false)}>Disconnect</button>
                </div>
              </>
            : <>
                <div style={{fontSize:12,color:"#aaa",marginBottom:12}}>Not connected</div>
                <button style={S.btnPrimary} onClick={()=>alert("QBO OAuth integration — requires Intuit Developer API keys. We will set this up as a next step.")}>Connect QuickBooks</button>
              </>
          }
        </div>
        <div style={S.card}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:12}}>Sync Settings</div>
          {[["Sync invoices to QBO",true],["Import clients from QBO",true],["Auto-create expense entries",false]].map(([label,on])=>(
            <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"0.5px solid #f0efe8",fontSize:13}}>
              <span>{label}</span>
              <div style={{width:36,height:20,background:on?"#2CA01C":"#ccc",borderRadius:10,position:"relative",cursor:"pointer"}}>
                <div style={{position:"absolute",top:2,[on?"right":"left"]:2,width:16,height:16,borderRadius:"50%",background:"#fff"}}/>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={S.card}>
        <div style={{fontSize:13,fontWeight:500,marginBottom:8}}>Partner Integrations</div>
        <div style={{fontSize:12,color:"#888",marginBottom:12}}>As a certified partner accountant, Ficsori Accounting supports the following payroll platforms:</div>
        <div style={{display:"flex",gap:10}}>
          {["ADP","Gusto","QBO Payroll"].map(p=>(
            <div key={p} style={{fontSize:12,padding:"6px 14px",borderRadius:8,border:"0.5px solid #e0dfd8",background:"#f5f5f0",color:"#555"}}>{p}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
